import { getAuth } from 'firebase/auth';

export default () => {
	console.info('🎬 signOut');
	return getAuth().signOut();
};
